import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import userReducer from "../slices/userSlice";
import roleReducer from "../slices/roleSlice";
import loaderReducer from "../slices/loaderSlice";
import loginViewReducer from "../slices/loginViewSlice";
import alertReducer from "../slices/alertSlice";
import loginReducer from "../slices/loginSlice";
import registerCandidateReducer from "../slices/registerCandidateSlice";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import resetPasswordReducer from "../slices/resetPasswordSlice";
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["registerCandidate","loginView"], //
};

const rootReducer = combineReducers({
  user: userReducer,
  role: roleReducer,
  login: loginReducer,
  loader: loaderReducer,
  loginView: loginViewReducer,
  alert: alertReducer,
  resetPassword: resetPasswordReducer,
  registerCandidate: registerCandidateReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
